export const SURF_FORECAST_MAX_AGE_MS = 12 * 60 * 60 * 1000;

export function surfForecastFreshness(timestamp: string | null | undefined, now: number): 'fresh' | 'stale' | 'unknown' {
  const updated = timestamp ? Date.parse(timestamp) : NaN;
  if (!Number.isFinite(updated) || !Number.isFinite(now) || updated > now + 60000) return 'unknown';
  return now - updated > SURF_FORECAST_MAX_AGE_MS ? 'stale' : 'fresh';
}

/** Local clock updates only. Checking age must never trigger a conditions read. */
export function watchSurfClock(onChange: (now: number) => void): () => void {
  const update = () => { if (document.visibilityState === 'visible') onChange(Date.now()); };
  const timer = window.setInterval(update, 60000);
  document.addEventListener('visibilitychange', update);
  window.addEventListener('focus', update);
  return () => {
    window.clearInterval(timer);
    document.removeEventListener('visibilitychange', update);
    window.removeEventListener('focus', update);
  };
}
